<template>
  <div class="q-pt-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      title="Centros de Custo já com regra "
      :rows="rows"
      :columns="columns"
      :loading="disable"
      class="tabela-tamanho-fixo"
      dense
      v-model:pagination="pagination"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-minimo="props">
        <q-td>
          <div v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.pivot.minimum_days" />
          </div>
          <span v-else>{{ props.row.pivot.minimum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-maximo="props">
        <q-td>
          <div v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.pivot.maximum_days" />
          </div>
          <span v-else>{{ props.row.pivot.maximum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-amount="props">
        <q-td>
          <div v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.pivot.max_amount" />
          </div>
          <span v-else>{{ props.row.pivot.max_amount }}</span>
        </q-td>
      </template>
      <template #body-cell-control="props">
        <q-td style="width: 220px">
          <div v-if="editarr == props.row.id">
            <q-select
              :options="control"
              dense
              outlined
              label="Controle"
              option-label="label"
              option-value="value"
              v-model="props.row.pivot.control_types"
              map-options
            />
          </div>
          <span v-else>
            <span
              v-if="
                props.row.pivot.control_types?.value != '' &&
                props.row.pivot.control_types?.value != undefined
              "
            >
              {{ props.row.pivot.control_types.label }}
            </span>
            <span v-else>
              {{
                props.row.pivot.control_types == "ambos"
                  ? "EMAIL E STATUS TROCA (WEB)"
                  : props.row.pivot.control_types == ""
                  ? "Todos"
                  : props.row.pivot.control_types == "nenhum"
                  ? "NENHUM"
                  : props.row.pivot.control_types == "email"
                  ? "SOMENTE EMAIL"
                  : props.row.pivot.control_types == "farol"
                  ? "SOMENTE STATUS TROCA (WEB)"
                  : ""
              }}
            </span>
          </span>
        </q-td>
      </template>
      <template #body-cell-critico="props">
        <q-td style="width: 180px">
          <div v-if="editarr == props.row.id">
            <q-select
              :options="critico"
              dense
              outlined
              label="Critico"
              option-label="label"
              option-value="value"
              map-options
              v-model="props.row.pivot.critico"
            />
          </div>
          <div v-else>
            <span v-if="props.row.pivot.critico == 0">NÃO</span>
            <span v-else>SIM</span>
          </div>
        </q-td>
      </template>
      <template #body-cell-editar="props">
        <q-td>
          <div v-if="editarr != props.row.id">
            <q-btn
              @click="
                editarr == props.row.id
                  ? (editarr = '')
                  : (editarr = props.row.id)
              "
              color="primary"
              round
              icon="edit"
              class="q-ml-sm"
            />
          </div>

          <div v-else-if="editarr == props.row.id">
            <q-btn
              @click="editar(props.row), (editarr = '')"
              color="positive"
              round
              icon="check"
              class="q-ml-sm"
            />
          </div>
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            @click="deletar(props.row.id)"
            color="negative"
            round
            icon="delete"
            class="q-ml-sm"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "code",
    label: "Código CC",
    field: "code",
    align: "left",
  },
  {
    name: "name",
    label: "Descrição",
    field: "name",
    align: "left",
  },
  {
    name: "minimo",
    label: "Prazo Min.",
    field: (row) => row.pivot.minimum_days,
    align: "left",
  },
  {
    name: "maximo",
    label: "Prazo Máx.",
    field: (row) => row.pivot.maximum_days,
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: (row) => row.pivot.max_amount,
    align: "left",
  },
  {
    name: "control",
    label: "Tipo Controle",
    field: (row) => row.pivot.control_types,
    align: "left",
  },
  {
    name: "critico",
    label: "Crítico?",
    field: "critico",
    align: "left",
  },
  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
export default {
  props: ["atualizar"],
  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const route = useRoute();
    const dados = JSON.parse(route.params.id);
    const editarr = ref("");
    const regras = ref("");
    const criticoValue = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getCentrosGrupos = async (page = 1, rowsPerPage = 15) => {
      let response = await store.dispatch("grupoProdutos/centroCustoRegras", {
        unidade: store.state.org.unidadeData.id,
        per_page: rowsPerPage,
        page: page,
        search: filter.value,
        id: dados.id,
      });

      rows.value = response.data.results.data;
      pagination.value.rowsPerPage = response.data.results.per_page;
      pagination.value.rowsNumber = response.data.results.total;
      pagination.value.page = response.data.results.current_page;

      disable.value = false;
    };

    onMounted(getCentrosGrupos);

    const handleRequest = async () => {
      getCentrosGrupos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const editar = async (value) => {
      try {
        await store.dispatch("grupoProdutos/editarCustoRegras", {
          unidade: store.state.org.unidadeData.id,
          id: dados.id,
          maximum_days: value.pivot.maximum_days,
          minimum_days: value.pivot.minimum_days,
          control_types: value.pivot.control_types?.label
            ? value.pivot.control_types.value
            : value.pivot.control_types,
          amount: value.pivot.max_amount,
          cost_center_id: value.id,
          critico: value.pivot.critico.label
            ? value.pivot.critico.value
            : value.pivot.critico,
        });

        $q.notify({
          message: "editado com sucesso sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        regras.value = "";
        criticoValue.value = "";
        getCentrosGrupos();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletar = async (id) => {
      try {
        await store.dispatch("grupoProdutos/deletarCentroCustoRegras", {
          center_id: id,
          id: dados.id,
        });

        $q.notify({
          message: "removido com sucesso sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getCentrosGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro a o remover",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getCentrosGrupos();
      }
    );

    return {
      columns,
      rows,
      getCentrosGrupos,
      pagination,
      handleRequest,
      disable,
      filter,
      editar,
      editarr,
      deletar,
      regras,
      criticoValue,
      control: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "EMAIL E STATUS TROCA (WEB)",
          value: "ambos",
        },
        {
          label: "NENHUM",
          value: "nenhum",
        },
        {
          label: "SOMENTE EMAIL",
          value: "email",
        },
        {
          label: "SOMENTE STATUS TROCA (WEB)",
          value: "farol",
        },
      ],
      critico: [
        {
          label: "SIM",
          value: 1,
        },
        {
          label: "NÃO",
          value: 0,
        },
      ],
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
